import { isEmpty } from 'lodash'
import { nanoid } from 'nanoid'
import { useMemo } from 'react'
import {
  isDateType,
  isNumericType,
  isStringType,
  isMapstackProperty
} from 'utils'
import { useFilters } from '~map-filter-view/states/filter'
import { useMap } from '~map-filter-view/states/map'
import useDateOperator from '../hooks/useDateOperator'
import useNumericOperator from '../hooks/useNumericOperator'
import useStringOperator from '../hooks/useStringOperator'
import { PropertiesListAll as View } from 'ui-components'

const uniqueCategoryLimit = 100

const PropertiesList = (props) => {
  const {
    onFilterRemove = () => {},
    onFilterUpdate = () => {},
    onSetActiveFilters = () => {}
  } = props
  const filters = useFilters()
  const map = useMap()

  const { getRange } = useNumericOperator()
  const { getOptions, countOptions } = useStringOperator()
  const { getDateRange } = useDateOperator()

  const getPropertyValue = (property) => {
    const { type, name } = property

    switch (true) {
      case isStringType(type):
        return getOptions(name)

      case isNumericType(type):
        return getRange(name)

      case isDateType(type):
        return getDateRange(name)

      default:
        throw Error('Unsupport property type')
    }
  }

  const propertiesValue = useMemo(() => {
    const values = map.properties
      .filter((property) => !isMapstackProperty(property.name))
      .filter((property) => {
        if (!isStringType(property.type)) return true
        return countOptions(property.name) < uniqueCategoryLimit
      })
      .map((property) => {
        const fitler = filters?.find((item) => item.name === property.name)
        return {
          id: fitler?.id || nanoid(5),
          name: property.name,
          type: property.type,
          value: getPropertyValue(property),
          selectedValue: fitler?.value
        }
      })
      .filter(
        (item) => !isStringType(item.type) || item.value?.options?.length > 1
      )

    return values || []
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map.properties, filters])

  const removeFilterThrowable = (filter) => {
    const { value, id } = filter
    if (!isEmpty(value)) return
    onFilterRemove(id)
    throw new Error('Empty Options')
  }

  const handleApplyFilter = (filter) => {
    try {
      removeFilterThrowable(filter)
      onFilterUpdate(filter)
    } catch (error) {
      // eslint-disable-next-line no-console
    }
  }

  const handleRemoveFilter = (id) => {
    onFilterRemove(id)
  }

  const handleFiltersActiveChange = (activeFilters) => {
    onSetActiveFilters(activeFilters)
  }

  return (
    <View
      propertiesValue={propertiesValue}
      onFilterChange={handleApplyFilter}
      onFilterRemove={handleRemoveFilter}
      onFiltersActiveChange={handleFiltersActiveChange}
    />
  )
}

export { PropertiesList }
